export default __webpack_public_path__ + "static/media/youtube-logo.d3fe21dd.svg";